/**
 * 应用配置文件
 * 统一管理所有环境变量和配置项
 */

// 环境配置
export const config = {
  // 基础配置
  env: process.env.NODE_ENV || 'development',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  sys: process.env.VUE_APP_SYS || 'lysora',

  // API配置
  // api: {
  //   baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api',
  //   timeout: parseInt(process.env.VUE_APP_API_TIMEOUT) || 10000,
  //   version: process.env.VUE_APP_API_VERSION || 'v1',
  // },

  // // 应用配置
  // app: {
  //   title: process.env.VUE_APP_TITLE || 'Help Center International',
  //   version: process.env.VUE_APP_VERSION || '1.0.0',
  //   description: process.env.VUE_APP_DESCRIPTION || 'International Help Center Application',
  // },

  // // 开发服务器配置
  // devServer: {
  //   host: process.env.VUE_APP_DEV_SERVER_HOST || '0.0.0.0',
  //   port: parseInt(process.env.VUE_APP_DEV_SERVER_PORT) || 9000,
  //   open: process.env.VUE_APP_DEV_SERVER_OPEN === 'true',
  // },

  // // 功能开关
  // features: {
  //   debug: process.env.VUE_APP_DEBUG === 'true',
  //   logLevel: process.env.VUE_APP_LOG_LEVEL || 'info',
  //   enablePerformanceMonitoring: process.env.VUE_APP_ENABLE_PERFORMANCE_MONITORING === 'true',
  //   enableErrorReporting: process.env.VUE_APP_ENABLE_ERROR_REPORTING === 'true',
  // },

  // // 第三方服务配置
  // thirdParty: {
  //   gaId: process.env.VUE_APP_GA_ID || '',
  //   baiduTongjiId: process.env.VUE_APP_BAIDU_TONGJI_ID || '',
  //   umengId: process.env.VUE_APP_UMENG_ID || '',
  // },

  // // 文件上传配置
  // upload: {
  //   maxFileSize: parseInt(process.env.VUE_APP_MAX_FILE_SIZE) || 10, // MB
  //   allowedFileTypes: process.env.VUE_APP_ALLOWED_FILE_TYPES || 'image/*,application/pdf,.doc,.docx,.xls,.xlsx',
  // },

  // // 缓存配置
  // cache: {
  //   expireTime: parseInt(process.env.VUE_APP_CACHE_EXPIRE_TIME) || 3600, // 秒
  //   enableLocalStorage: process.env.VUE_APP_ENABLE_LOCAL_STORAGE === 'true',
  // },

  // // 国际化配置
  // i18n: {
  //   defaultLocale: process.env.VUE_APP_DEFAULT_LOCALE || 'zh-CN',
  //   supportedLocales: (process.env.VUE_APP_SUPPORTED_LOCALES || 'zh-CN,en-US,ja-JP').split(','),
  // },

  // // 安全配置
  // security: {
  //   enableHttps: process.env.VUE_APP_ENABLE_HTTPS === 'true',
  //   enableCors: process.env.VUE_APP_ENABLE_CORS === 'true',
  //   enableXssProtection: process.env.VUE_APP_ENABLE_XSS_PROTECTION === 'true',
  // },
}

// 获取配置的辅助函数
export const getConfig = (key) => {
  const keys = key.split('.')
  let value = config
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k]
    } else {
      return undefined
    }
  }
  
  return value
}

// 日志函数
/**
 * 日志记录器
 * 提供不同级别的日志记录功能，支持调试、信息、警告和错误日志
 * 根据配置的日志级别控制输出。具体的优先级为：error > warn > info > debug
 */

export const logger = {
  debug: (message, ...args) => {
    if (config.features.debug) {
      console.log(`[DEBUG] ${message}`, ...args)
    }
  },
  info: (message, ...args) => {
    if (['debug', 'info'].includes(config.features.logLevel)) {
      console.info(`[INFO] ${message}`, ...args)
    }
  },
  warn: (message, ...args) => {
    if (['debug', 'info', 'warn'].includes(config.features.logLevel)) {
      console.warn(`[WARN] ${message}`, ...args)
    }
  },
  error: (message, ...args) => {
    if (['debug', 'info', 'warn', 'error'].includes(config.features.logLevel)) {
      console.error(`[ERROR] ${message}`, ...args)
    }
  },
}

// 默认导出
export default config 